import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';

@Injectable()
export class AppSettings {
    public static buildNumber = 75;
    public static version = '1.9.1';
    public static publishDate = 'June 22, 2026';

    public static currYear = new Date().getFullYear();

    public static maxImageSizeMB = 2; // 2MB
    public static tabletRez = 1200;
    public static mobileRez = 750;
    public static pieColors = ["#fe9a8b", "#9ec3e6", "#c9eb8a", "#d39ed4", "#ffcc80", "#fff584", "#d3d1e6", "#fde3f2", "#a4e0d9"];



    // Development
    public static get isProduction() { return environment.production; }
    public static get apiURL() { return environment.apiURL; }
    public static get hubURL() { return environment.hubURL; }
    public static get baseUrl() { return environment.baseUrl; }
    public static get clientRootUrl() { return environment.clientRootUrl; }
    public static get bbDashRootUrl() { return environment.bbDashRootUrl; }
    public static get raffleDashRootUrl() { return environment.raffleDashRootUrl; }
    public static get raffleClientRootUrl() { return environment.raffleClientRootUrl; }
    public static get raffleApiUrl() { return environment.raffleApiUrl; }
}
